export const parseLoyaltyFooterContentIds = (value) => {
    if (Array.isArray(value)) {
        return value.map(String).map((id) => id.trim()).filter(Boolean)
    }

    return String(value || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean)
}

const getContentIdentifiers = (item) =>
    [
        item?.ContentLink?.GuidValue,
        item?.ContentLink?.Id,
        item?.Expanded?.ContentLink?.GuidValue,
        item?.Expanded?.ContentLink?.Id,
        item?.Expanded?.Link?.GuidValue,
        item?.Expanded?.Link?.Id,
        item?.Expanded?.Link?.Expanded?.GuidValue,
        item?.Expanded?.Link?.Expanded?.Id,
        item?.Expanded?.Key,
        item?.Expanded?.Name
    ]
        .filter(Boolean)
        .map(String)

/**
 * Returns true when a footer CMS item should be treated as loyalty content
 * and hidden for international locales.
 *
 * Checks CMS flags and configured content IDs first. When linkContext is provided
 * (footer column nav items), falls back to label/href matching for CMS entries
 * that are not yet tagged in Optimizely.
 *
 * @param {Object} item - Optimizely footer content item.
 * @param {string[]} loyaltyContentIds - Content GUID/Id values from HIDE_LOYALTY_FOOTER_CONTENT_IDS.
 * @param {{label?: string, href?: string}} [linkContext] - Resolved nav link label and href.
 * @returns {boolean}
 */
export const isLoyaltyFooterContent = (item, loyaltyContentIds, linkContext) => {
    const hasExplicitLoyaltyFlag =
        item?.Expanded?.HideForInternational === true ||
        item?.Expanded?.hideForInternational === true ||
        item?.Expanded?.IsLoyaltyContent === true ||
        item?.Expanded?.isLoyaltyContent === true

    if (hasExplicitLoyaltyFlag) {
        return true
    }

    const identifiers = getContentIdentifiers(item)
    if (identifiers.some((identifier) => loyaltyContentIds.includes(identifier))) {
        return true
    }

    if (linkContext) {
        const label = String(linkContext.label || '').toLowerCase()
        const href = String(linkContext.href || '').toLowerCase()

        if (label.includes('loyalty') || href.includes('my-rewards')) {
            return true
        }
    }

    return false
}
